var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1H0.5C0.223437 1 0 1.22344 0 1.5V11.5C0 11.7766 0.223437 12 0.5 12H13.5C13.7766 12 14 11.7766 14 11.5V1.5C14 1.22344 13.7766 1 13.5 1ZM12.875 4.25H9.5625V2.125H12.875V4.25ZM12.875 7.75H9.5625V5.25H12.875V7.75ZM5.4375 5.25H8.5625V7.75H5.4375V5.25ZM8.5625 4.25H5.4375V2.125H8.5625V4.25ZM1.125 5.25H4.4375V7.75H1.125V5.25ZM1.125 2.125H4.4375V4.25H1.125V2.125ZM1.125 8.75H4.4375V10.875H1.125V8.75ZM5.4375 8.75H8.5625V10.875H5.4375V8.75ZM12.875 10.875H9.5625V8.75H12.875V10.875Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserList);
export default __webpack_public_path__ + "static/media/user-list.f728dbd0a69f9db003db0cbe508f5254.svg";
export { ForwardRef as ReactComponent };